module.exports = __webpack_public_path__ + "static/media/48.959e50e8.png";